import axios from "../config/axios-kb"


export const CategoryRepository = {
  getAll: () => {
    return axios.get(`/api/category`);
  },
  getCategoriesByMember: (member) => {
    return axios.get(`/api/organization-member/${member}/categories`);
  },
  delete: (id) => {
    return axios.delete(`/api/category/${id}`)
  },
  create: (data) => {
    return axios.post('/api/category', data)
  },
  edit: (id, data) => {
    return axios.put(`/api/category/${id}`, data)
  }
}